import React, { useState } from 'react';

const FileUpload = ({ onFileUpload }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (file) {
      onFileUpload(file);
      alert('Arquivo carregado com sucesso!');
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-gray-900 rounded-lg">
      <h2 className="text-2xl font-semibold text-primary mb-6">
        Upload de Arquivo
      </h2>

      {/* Input para selecionar arquivo */}
      <input
        type="file"
        onChange={handleFileChange}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 focus:outline-none"
      />

      {/* Nome do arquivo selecionado */}
      {file ? (
        <p className="mt-4 text-sm text-gray-700">
          Arquivo selecionado: {file.name}
        </p>
      ) : (
        <p className="mt-4 text-sm text-gray-500">
          Nenhum arquivo selecionado.
        </p>
      )}

      {/* Botão de Upload */}
      <button
        className={`mt-4 py-2 px-4 rounded ${
          file
            ? 'bg-green-500 text-white hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        } transition-colors duration-300`}
        onClick={handleUpload}
        disabled={!file}
      >
        Upload
      </button>
    </div>
  );
};

export default FileUpload;
